import { render, staticRenderFns } from "./furnitureshop-reward.vue?vue&type=template&id=21fcc512&scoped=true&"
import script from "./furnitureshop-reward.vue?vue&type=script&lang=js&"
export * from "./furnitureshop-reward.vue?vue&type=script&lang=js&"
import style0 from "./furnitureshop-reward.vue?vue&type=style&index=0&id=21fcc512&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fcc512",
  null
  
)

export default component.exports